import React, { useEffect, useState } from "react";
import Banner from "../../../Components/Common/Banner";
import contact_service_req_Icon from "../../../Assets/images/contact_service_req_Icon.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

const ServiceRequest = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const phoneValue = value.replace(/\D/g, "");

      const maxLength = formData.countryCode === "+971" ? 9 : 10;

      if (phoneValue.length <= maxLength) {
        setFormData((prev) => ({
          ...prev,
          phone: phoneValue,
        }));
      }

      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getAllService = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/services/service-name`,
      );
      setServiceData(res.data.services);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getAllService();
  }, []);

  const validatePhone = () => {
    const { countryCode, phone } = formData;

    if (!phone.trim()) {
      toast.error("Please enter your phone number");
      return false;
    }

    if (countryCode === "+91") {
      // India: 10 digits, starts with 6-9
      if (!/^[6-9]\d{9}$/.test(phone)) {
        toast.error("Please enter a valid 10-digit Indian mobile number");
        return false;
      }
    }

    if (countryCode === "+1") {
      // USA: 10 digits
      if (!/^[2-9]\d{9}$/.test(phone)) {
        toast.error("Please enter a valid 10-digit USA phone number");
        return false;
      }
    }

    if (countryCode === "+971") {
      // UAE: 9 digits, mobile starts with 5
      if (!/^5\d{8}$/.test(phone)) {
        toast.error("Please enter a valid 9-digit UAE mobile number");
        return false;
      }
    }

    return true;
  };

  const validateForm = () => {
    const { name, email, phone, service, message } = formData;

    // Name validation
    if (!name.trim()) {
      toast.error("Please enter your name");
      return false;
    }

    if (name.trim().length < 2) {
      toast.error("Name must contain at least 2 characters");
      return false;
    }

    // Email validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!email.trim()) {
      toast.error("Please enter your email");
      return false;
    }

    if (!emailRegex.test(email.trim())) {
      toast.error("Please enter a valid email address");
      return false;
    }

    // Phone validation

    validatePhone();

    // Service validation
    if (!service.trim()) {
      toast.error("Please select a service");
      return false;
    }

    // Message validation
    if (!message.trim()) {
      toast.error("Please enter your message");
      return false;
    }

    if (message.trim().length < 10) {
      toast.error("Message must contain at least 10 characters");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const { name, email, countryCode, phone, service, message } = formData;

      // Combine country code + phone
      const finalPhone = `${countryCode}${phone}`;

      const postData = {
        name: name.trim(),
        email: email.trim(),
        phone: finalPhone,
        service,
        message: message.trim(),
      };

      console.log("Post Data:", postData);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/service/send-request-service`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      console.log("Post Response:", response.data);

      toast.success("Successfully submitted your request");

      setFormData({
        name: "",
        email: "",
        countryCode: "+91",
        phone: "",
        service: "",
        message: "",
      });
    } catch (error) {
      console.error("Error:", error);

      toast.error(
        error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Banner
        pageName="Request Quotation"
        visible={false}
        breadcrummbs="Home / Contact Us / Request For Service"
        image={contact_service_req_Icon}
      />
      <ToastContainer />
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-10 justify-center mt-8 lg:px-20 md:px-10 px-5 py-10">
        <div className="w-full max-w-2xl">
          <form
            onSubmit={handleSubmit}
            className="border border-gray-300 md:p-8 p-4 rounded-lg shadow-lg bg-white"
          >
            <div className="flex flex-col justify-center items-center">
              <h1 className="text-[#7a96bd] font-medium md:text-xl border-b-2 border-[#7a96bd] inline-block mb-4">
                Share Your Project Scope
              </h1>
              <div className="flex w-full flex-col gap-4 mt-4 ">
                <div className="grid grid-cols-2 gap-2 w-full">
                  <div className="flex flex-col">
                    <label className="text-gray-700 mb-1" htmlFor="name">
                      Name
                    </label>
                    <input
                      type="text"
                      placeholder="Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="border border-gray-300 px-4 py-2 rounded w-full"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="text-gray-700 mb-1" htmlFor="email">
                      Email
                    </label>
                    <input
                      type="email"
                      placeholder="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="border border-gray-300 px-4 py-2 rounded w-full"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2  w-full gap-2 mt-4">
                  {/* <div className="flex flex-col">
                    <label className="text-gray-700 mb-1" htmlFor="phone">
                      Phone
                    </label>
                    <input
                      type="text"
                      placeholder="Phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="border border-gray-300 px-4 py-2 rounded"
                    />
                  </div> */}

                  <div className="flex flex-col">
                    <label className="text-gray-700 mb-1" htmlFor="phone">
                      Phone <span className="text-red-500">*</span>
                    </label>

                    <div className="flex w-full">
                      <select
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleChange}
                        className="w-[70px] h-[42px] border border-gray-300 border-r-0 px-2 rounded-l-md bg-gray-50 text-sm text-gray-700 focus:outline-none focus:ring-1 focus:ring-[#7a96bd] cursor-pointer"
                      >
                        <option value="+91"> +91</option>
                        <option value="+1">+1</option>
                        <option value="+971"> +971</option>
                      </select>

                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        maxLength={formData.countryCode === "+971" ? 9 : 10}
                        inputMode="numeric"
                        placeholder={
                          formData.countryCode === "+971"
                            ? "501234567"
                            : "Enter phone number"
                        }
                        className="border border-gray-300 px-4 py-2 rounded-r w-full focus:outline-none focus:ring-2 focus:ring-[#7a96bd]"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <label className="text-gray-700 mb-1" htmlFor="service">
                      Service
                    </label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      className="border border-gray-300 px-4 py-2 rounded"
                    >
                      <option value="">Select a service</option>
                      {serviceData.map((item, id) => (
                        <option key={id} value={item.slug}>
                          {item.heading}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex flex-col">
                  <label className="text-gray-700 mb-1" htmlFor="message">
                    Message
                  </label>
                  <textarea
                    placeholder="Your CoverLetter/message sent to the employer"
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    className="border border-gray-300 px-4 py-2 rounded w-full"
                  />
                </div>
                <button
                  disabled={isLoading}
                  className="bg-[#7a96bd] text-white w-[150px] px-4 flex items-center justify-center gap-2 py-2 mt-4 hover:bg-black cursor-pointer rounded-md"
                >
                  {isLoading ? (
                    <>
                      <div class="rounded-md h-5 w-5 border-2 border-white animate-spin"></div>
                      Loading..
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
        <div>
          <img
            src="https://plus.unsplash.com/premium_photo-1664475675826-c356dc411613?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt=""
            className="rounded-xl"
          />
        </div>
      </div>
    </>
  );
};

export default ServiceRequest;
